export default {
	title: "Guías",
	spiritualLine: "Línea Espiritual",
	primaryWillReplaceExisting: "Al marcar como principal, el médium/guía principal anterior en la misma línea espiritual será desmarcado automáticamente.",
	activeGuidesCount: "Guías Activos",
	confirmRemoveGuide: "¿Está seguro de que desea eliminar este guía?",
	create: "Crear Guía",
	createError: "Error al crear guía",
	createSuccess: "¡Guía creado con éxito!",
	deleteConfirmation: "¿Desea realmente eliminar el guía {name}?",
	deactivate: "Desactivar",
	deactivateConfirmation: "¿Desactivar el guía {name}? Dejará de aparecer en los listados, pero podrá reactivarse más tarde.",
	deletePermanent: "Eliminar permanentemente",
	deletePermanentConfirmation: "¿Eliminar permanentemente el guía {name}? Esta acción no se puede deshacer.",
	deletePermanentWarning: "La eliminación permanente solo es posible si el guía no tiene ningún vínculo (médiums, atenciones, tickets o retornos). De lo contrario, use la opción Desactivar.",
	details: {
		activePeople: "Personas Activas",
		basicInfo: "Información Básica",
		noPeopleAssociated: "Ninguna persona asociada a este guía",
		totalConsultations: "Consultas",
		totalPeople: "Total de Personas",
	},
	edit: "Editar Guía",
	empty: {
		description: "Registre los guías espirituales que actúan en el terreiro",
		title: "Ningún guía espiritual encontrado",
	},
	errorActivatingGuide: "Error al activar guía",
	errorDeactivatingGuide: "Error al desactivar guía",
	errorLoadingAvailableGuides: "Error al cargar guías disponibles",
	errorLoadingGuides: "Error al cargar guías",
	errorRemovingGuide: "Error al eliminar guía",
	errorSavingGuide: "Error al guardar guía",
	errorSettingPrimary: "Error al definir médium principal",
	errors: {
		fetchError: "Error al cargar datos del guía",
		invalidId: "ID del guía inválido",
	},
	filter: {
		active: "Activos",
		all: "Todos",
		inactive: "Inactivos",
	},
	form: {
		associatedPersonHint: "Esta persona ya está asociada al guía y no puede ser modificada",
		associatedPersonTooltip: "Para cambiar la persona asociada, use la gestión de personas del guía",
		descriptionHint: "Descripción sobre el guía",
		descriptionLabel: "Descripción",
		isActiveLabel: "Guía activo",
		isPrimaryLabel: "Médium principal",
		nameHint: "Introduzca el nombre del guía",
		nameLabel: "Nombre del Guía",
		noPersonFound: "Ninguna persona encontrada",
		personHint: "Seleccione una persona asociada al guía",
		personLabel: "Persona (Opcional)",
		personSearchPlaceholder: "Escriba para buscar una persona...",
		primaryMediumLabel: "Médium Principal",
		spiritualLineHint: "Seleccione la línea espiritual",
		spiritualLineLabel: "Línea Espiritual",
		willBePrimaryMedium: "Será definido como médium principal de este guía",
	},
	guide: "Guía",
	guideActivatedSuccess: "Guía activado con éxito",
	guideAddedSuccess: "Guía agregado con éxito",
	guideDeactivatedSuccess: "Guía desactivado con éxito",
	guideRemovedSuccess: "Guía eliminado con éxito",
	guideUpdatedSuccess: "Guía actualizado con éxito",
	messages: {
		createError: "Error al crear guía",
		created: "Guía {name} creado con éxito",
		deleteError: "Error al eliminar guía",
		deleted: "Guía {name} eliminado con éxito",
		deactivated: "Guía {name} desactivado con éxito",
		deactivateError: "Error al desactivar guía",
		deletedPermanent: "Guía {name} eliminado permanentemente",
		deletePermanentError: "Error al eliminar guía permanentemente",
		loading: "Cargando guía...",
		updateError: "Error al actualizar guía",
		updated: "Guía {name} actualizado con éxito",
	},
	noGuidesFound: "Ningún guía encontrado",
	primaryGuide: "Guía Principal",
	primaryMedium: "Médium Principal",
	primarySetSuccess: "Médium principal definido con éxito",
	search: "Buscar guías...",
	setPrimary: "Definir como Principal",
	tabs: {
		overview: "Visión General",
		persons: "Personas",
	},
	totalGuidesCount: "Total de Guías",
	validation: {
		descriptionMaxLength: "La descripción debe tener máximo 500 caracteres",
		nameMaxLength: "El nombre debe tener máximo 100 caracteres",
		nameRequired: "El nombre es obligatorio",
		spiritualLineRequired: "La línea espiritual es obligatoria",
	},
	withMediumsCount: "Con Médiums",
};
